<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            <i>"Bringing you together, to make our achievements greater"</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class="uk-heading-line specHeading uk-text-center"><span>Computer Labs</span></h1>
        <div class="uk-container uk-container-small">
          <div>

            <img class="uk-align-center" src="../assets/coned.jpg" alt="">

            <p class="">
              The following policies are put into place to ensure availability and maintain a
              positive user experience in NCU Computer Labs. Use of student computer
              labs implies consent to these policies. Computer Lab Attendants are instructed to
              enforce all policies and regulations, provide technical assistance, and report
              problems.
            </p>

          </div>
          <div class="uk-child-width-1-1@m" uk-grid>

            <div>

              <h4 class="uk-heading-bullet specHeading">General Lab Policies:</h4>
              <ul class="uk-list uk-list-divider ">

                <li class="">
                  Users must possess a current Northern Caribbean University ID card to access
                  computers lab. If an ID is lost or damaged, the user need to get a replacement to
                  continue using the lab.
                </li>
                <li class="">
                  Northern Caribbean University (NCU) is not responsible for items left in the
                  computer labs or the loss of documents/files due to power failures, computer
                  hardware/software failures, network difficulties, and/or users not periodically
                  saving their work.
                </li>
                <li class="">
                  The Business Labs #1 and #2, are reserved for class sessions. The MicroLab is
                  used for general purpose by any student who needs to use the Lab outside of
                  classes.
                </li>
                <li >
                  All of the stored information on the computers will be lost once the units have
                  been restarted. Documents cannot be saved to the computers. Students should
                  save any documents that they will need on a compact disk or removable drive to
                  ensure that the document will not be lost.
                </li>
                <li>
                  Academic work by current NCU students takes precedence over all other uses. A
                  user engaged in non-academic activities may be asked to give up his/her
                  computer to allow another user to carry out legitimate academic work.
                </li>
                <li>
                  <span class="uk-uk-text-bold">Account Usage:</span>
                  <ul class="uk-list uk-list-bullet">
                    <li>
                      Safeguard your password and do not share it with others.
                    </li>
                    <li>
                      Do not use a user Username and password that has not been assigned to
                      you.
                    </li>
                    <li>
                      Remember to “Log Off” at the end of each session.
                    </li>
                  </ul>
                </li>
                <li>
                  <span class="uk-uk-text-bold">Computer time limit:</span>
                  <ul class="uk-list uk-list-bullet">
                    <li>
                      During times of heavy usage, the Computer Lab Manager may institute a two-
                      hour time limit on workstation sessions in the Academic Computing Labs. If at the
                      end of a two-hour session there is no one waiting to use a workstation, the
                      student may continue to work there until such time as a demand for the
                      workstations arises.
                    </li>

                  </ul>
                </li>

              </ul>

            </div>

          </div>


        </div>
      </div>
      <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small">
          <div>
            <h4 class="uk-heading-bullet specHeading">Activities Prohibited in the Computer Labs</h4>
            <ul class="uk-list uk-list-divider ">
              <li>
                <span class="uk-uk-text-bold">Eating or Drinking:</span>
                <ul class="uk-list uk-list-bullet">
                  <li>
                    Food and drinks are strictly prohibited in the labs.
                  </li>

                </ul>
              </li>
              <li>
                <span class="uk-uk-text-bold">Noise and other disruption:</span> <br>
                <span class="uk-text-muted">All computer labs are quiet working environment. Users should therefore:</span>
                <ul class="uk-list uk-list-bullet">
                  <li>
                    Talk softly.
                  </li>
                  <li>Put cell phones on the "silent" or "vibrate".</li>
                  <li>Leave the computer lab to answer or make a cell phone call.</li>
                </ul>
              </li>

              <li class="">
                <span class="uk-text-bold">Inappropriate material</span>
                Viewing of pornography or other sexually explicit materials in the computer lab is
                not appropriate. If you engaging in such activity, you may be asked to stop the
                activity immediately and/or leave the Lab.
              </li>
              <li class="">
                <span class="uk-text-bold">Children in the Labs</span>
                Children are only allowed in computer labs if they are well-behaved and
                supervised at all times. Children may not use the computers or occupy
                workstation areas. At no time are children to be left unattended. UNISS reserves
                the right to request that children be removed from the lab if their presence creates
                a disturbance.
              </li>
              <li class="">
                <span class="uk-text-bold">Lab Assistants</span>
                Lab assistants in the labs are available to provide users with assistance in using
                the hardware and software. Lab assistants are not tutors and are specifically
                prohibited from working on student’s assignments. Hiring of lab assistants in
                specialized labs should be accomplished by the department using that resource.
                In specialized labs, assistants may perform tutorial functions, well as technical
                support functions.
              </li>
              <li>
                <span class="uk-uk-text-bold">Vandalism:</span> <br>

                <ul class="uk-list uk-list-bullet">
                  <li>
                    Students will be held responsible for destroying or deface furniture or any part
                    of a computer.
                  </li>
                </ul>
              </li>
              <li>
                <span class="uk-uk-text-bold">Printing:</span> <br>

                <ul class="uk-list uk-list-bullet">
                  <li>
                    At the start of a new semester a fully registered regular student is given 250
                    pages or a total of $1250.00 for printing. A fully registered module student is
                    given a total of $625.00 on their account to facilitate printing at the computer
                    lab.
                  </li>
                  <li>
                    The printing cost per page is $5.00 on one side the $10.00 on both sides.
                  </li>
                  <li>
                    At the end of every semester all student account balances will be erased.
                  </li>
                </ul>
              </li>
              <li>
                <span class="uk-uk-text-bold">Chapel:</span> <br>

                <ul class="uk-list uk-list-bullet">
                  <li>
                    On Mondays and Thursdays both Business Lab and Micro Lab will close at
                    2:00PM – 3:30PM to facilitate chapel sessions. No one is allowed inside the
                    lab at this time.
                  </li>
                </ul>
              </li>
              <li>
                <span class="uk-uk-text-bold">Attire:</span> <br>

                <ul class="uk-list uk-list-bullet">
                  <li>
                    Modest attire is required at all times.
                  </li>
                  <li>Jewelry is not allowed inside the computer labs. This includes earrings,
                    necklaces, rings (unless married), nose-rings, pendants and others.
                  </li>
                  <li>
                    No sleeveless blouse/shirt, shorts and slippers (male), tights (females) no
                    Gym clothes.
                  </li>
                  <li>
                    Unhealthy hygiene will not be tolerated.
                  </li>
                </ul>
              </li>


            </ul>

          </div>
          <p class=" uk-text-danger uk-text-bold">
            Please see the Computer Lab Assistant (CLA) on duty or contact the
            Computer Lab Help Desk (7302) for technical assistance.
            <br><br>
            **Violation of These Policies May Lead to Revocation of Lab Privileges for
            the semester and or Disciplinary Action**
          </p>
        </div>
      </div>

      <div class="uk-padding">
        <div class="uk-container uk-container-small">
          <h3 class="uk-heading-bullet specHeading">Frequently Asked Questions</h3>
          <ul class="uk-list uk-list-striped ">
            <li>
              <p class="">
                <span class="uk-text-bold">How do I access the Computer Labs?</span> <br>
                Users must possess a current Northern Caribbean University ID card to access the computers
                labs.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">I have never logged into the Computer Labs before. What are my username and password?</span> <br>
                Your computer login credentials are the same as your Aeorion credentials. Once you are
                registered, your account will be active.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">What Computer Labs are available for use?</span> <br>
                The Microlab is a general purpose lab used for printing, research and completing assignments
                outside of classes. The Business Labs (1 & 2) are reserved for Instructor led computer-based
                classes.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">What are the Computer Lab Hours of Operations?</span> <br>
                <ul class="uk-list uk-list-bullet">
                  <li>Sunday 10:00 AM - 7:00 PM</li>
                  <li>Monday - Thursday 8:00 AM - 10:00 PM</li>
                  <li>Friday 8:00 AM - 1:30 PM
                    <ul class="uk-list uk-list-divider">
                      <li>Closed for Chapel - Monday & Thursday 2:00 PM - 3:30 PM</li>
                      <li>Saturday CLOSED</li>
                    </ul>
                  </li>
                </ul>
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Is there a computer time limit?</span> <br>
                Student are allocated 3 hours’ maximum for daily usage. However, up to 2 hours extra can be
                given if the lab’s usage is low.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">How often should I save my work?</span> <br>
                It is recommended that you save your work frequently in order to prevent data loss. The Lab
                workers are not responsible for recovering lost documents.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">May I bring my laptop inside the lab?</span> <br>
                Yes, there is a dedicated area for laptop usage where you can utilize the Wi-Fi signal.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">May I bring food and drinks into the computer Lab?</span> <br>
                Foods and drinks are not permitted inside any of the computer labs.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">How may I retrieve an item lost in the computer labs?</span> <br>
                The computer labs are NOT responsible for lost or stolen items. If you have recently lost an
                item, return to the computer lab and ask a Lab Assistant to check the lost and found box. We
                will do our best to try to assist you.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">What software are available in the labs?</span> <br>
                <ul class="uk-list uk-list-bullet">
                  <li>Adobe Acrobat Reader DC</li>
                  <li>Bitdefender Endpoint Security</li>
                  <li>Blackboard Collaborate</li>
                  <li>Brackets</li>
                  <li>Google Chrome</li>
                  <li>IBM SPSS 25</li>
                  <li>Microsoft Edge</li>
                  <li>Microsoft Office 2016(Access, Excel, Word, OneNote, Outlook, PowerPoint, Publisher, )</li>
                  <li>Mozilla Firefox</li>
                  <li>PaperCut</li>
                  <li>Sage 50 Accounting</li>
                  <li>VLC Media Player</li>
                  <li>Visual Studio</li>
                  <li>Windows 7/10</li>

                </ul>
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">How does faculty Reserve a Computer Lab for unscheduled class/event?</span> <br>
                To reserve a computer lab, you may contact the Business Lab at 876-963-7302 or simply send
                an email to labsupport@ncu.edu.jm.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Can I print in the Computer Labs?</span> <br>
                The Computer Labs provide black and white printing; All labs are equipped with Kyocera
                Taskalfa 6500i black and white printer.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Can I print from my laptop inside the lab?</span> <br>
                Yes, Wireless printing and printing from laptops is now available via WebPrint. The lab
                assistants on duty will be able to help you with this.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Where can I print in color?</span> <br>
                The University Press and the Library are equipped the color printers to assist you.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Can I bring my own paper for printing inside the lab?</span> <br>
                Only paper provided by NCU Computer Labs is allowed in the lab printers.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">What is the PaperCut pop-up window on my screen?</span> <br>
                The PaperCut window displays your print credit balance. The balance depletes every time you
                send a document and it is released to print.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">What are the printing costs?</span> <br>
                Black and white printing is $5 per printed page. For 2-sided printing it will cost $10 per page.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">How do I release my job to print?</span> <br>
                The Lab Assistant will release your job from the print queue once you present your ID.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Does my print credit from last semester roll over into the next semester?</span> <br>
                The print credit from previous semester does not roll over into the next semester. Each student
                will receive 250 pages or $1250.00 in print credit at the beginning of their registered semester.
                Module students receive half of this amount, which is $625.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">Can I get a print refund if my documents didn’t print correctly?</span> <br>
                This is determined on a case by case basis. Your account will be reviewed by the lab manager
                and credited the necessary amount.
              </p>
            </li>
            <li>
              <p class="">
                <span class="uk-text-bold">How do I add more print credit funds to my account?</span> <br>
                You can add funds to your account by purchasing print credit at the Finance Office. Show your
                receipt to a lab supervisor and your account will be credited the amount purchased.
              </p>


            </li>

          </ul>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "unisslabs",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Computer Labs',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Computer Labs at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
